import { ipayEwalletTypes } from "../../../../app/Common/Enum/IpayEwalletType"
import { TableSessionType } from "../../../../app/Common/Enum/TableSessionType"

const CALCULATION_MODE_FPX_3_5_PERCENT = 1
const CALCULATION_MODE_FPX_RM1_PLUS_1_PERCENT = 2

export default class CalculationHelper {
    /**
     * Return the rate of transaction of format
     * {
     *      rate: float,
     *      base: float,
     *      msg : string,
     * }
     * 
     * where 
     * 0 <= rate <=1 - percentage to be charged
     * base >= 0 - The fixed amount to be added on top of the rate
     * msg - The error message if we are unable to calculate the rate/base 
     * 
     * Eg: Charge = base + (rate/100 * price)
     * 
     * @param {Object} row 
     * @returns  {Object}
     */
     static getRate = (row) => {

        if (row.calculated) {
            return {
                base        : row.calculated.base,
                rate        : row.calculated.rate,
                rateMsg     : row.calculated.rateMsg,
            }
        }

        // As of 2021-07, only FPX has base charge. Other payment method
        // are fully percentage base
        // 1. FPX
        //      base = RM 1.00, rate = 1.0 %
        // 
        let base = 0
        let rate = 0
        let rateMsg = null

        let bills = row.bills
        if (bills && Array.isArray(bills) && bills.length > 0) {
            let bill = bills[0]
            if (bill.ipay_transaction && bill.ipay_transaction.ipay_data) {
                let bankMID = bill.ipay_transaction.ipay_data.BankMID
                let authCode = bill.ipay_transaction.ipay_data.AuthCode || ""
                let eWalletType = ipayEwalletTypes.find(t => {
                    return t.mid == bankMID || (t.authCodePrefix && authCode.startsWith(t.authCodePrefix))
                })
                if (eWalletType) {
                    // return eWalletType.merchantRate
                    base = eWalletType.merchantRate.base
                    rate = eWalletType.merchantRate.rate
                }
                else {
                    // Unknown eWallet, use default rate for most provider
                    // return 2.5
                    base = 0.0
                    rate = 2.5
                }
            }
            else if (bill.kiple_transaction && bill.kiple_transaction.kiple_data) {
                const kipleData = bill.kiple_transaction.kiple_data
                if (kipleData.payment_type == 'cc') {
                    if (kipleData.source_type && kipleData.source_type.toLowerCase() == 'fc') {
                        // FC = Foreign Credit Card
                        base = 0.0
                        rate = 4.0
                    }
                    else {
                        // LCC = Local Credit Card
                        base = 0.0
                        rate = 3.0
                    }
                }
                else if (kipleData.payment_type == 'bank') {
                    switch (parseInt(bill.kiple_transaction.fee_calculation_mode)) {
                        case CALCULATION_MODE_FPX_3_5_PERCENT:
                            // Old rate
                            base = 0.0
                            rate = 3.5
                            break
                        case CALCULATION_MODE_FPX_RM1_PLUS_1_PERCENT:
                        default:
                            // FPX payment, RM 1.00 + 1%
                            base = 1.0
                            rate = 1.0
                    }
                }
                else if (bill.isManualCheckStatus) {
                    rateMsg = kipleData
                }
                else if (kipleData) {
                    rateMsg = "Unknown"
                }
            }
            else if (row.table_session_type_id == TableSessionType.DELIVERY) {
                // This part shall be imposible. Just in case, we charge a basic 1%

                // return 1.0
                base = 0.0
                rate = 1.0
            }
        }

        return {
            rate: rate,
            base: base,
            rateMsg : rateMsg,
        }
    }

    static getSettlementRawValue = (row, bill) => {
        if (row.calculated.settlementRawValue) {
            // Use cached value
            return row.calculated.settlementRawValue
        }
        let billTotal = bill.total
        if (row.merchant_table.merchant.merchant_settings.length > 0) {
            let isAllowMerchantUseOwnDeliveryTeam = row.merchant_table.merchant.merchant_settings.find(setting => {
                return setting.description == 'is_allow_merchant_use_own_delivery_team'
            })
            if (isAllowMerchantUseOwnDeliveryTeam && isAllowMerchantUseOwnDeliveryTeam.value == 1) {
                billTotal = bill.total_with_delivery_charge
            }
        }
        billTotal -= parseFloat(bill.merchant_cover_cost || 0)
        return parseFloat(billTotal)
    }
    static getMerchantSettleValue(row) {
        if (row.calculated && typeof row.calculated.merchantSettleValue !== 'undefined') {
            // return cached value
            return row.calculated.merchantSettleValue
        }

        let fee = parseFloat(CalculationHelper.getFee(row)) || 0.00
        let bills = row.bills
        if (bills && Array.isArray(bills) && bills.length > 0) {
            let bill = bills[0]
            let billTotal = CalculationHelper.getSettlementRawValue(row, bill)
            return CalculationHelper.round2dp(billTotal - fee).toFixed(2)
        }
        return '--'
    }
    static round2dp = (num) => {
        return (Math.round( num * 100 ) / 100)
    }
    static getFee = (row) => {
        // let rate = parseFloat(CalculationHelper.getRate(row))
        let rate, base, rateMsg

        if (row.calculated && typeof row.calculated.fee !== 'undefined') {
            // return cached value
            return row.calculated.fee
        }

        // JS destructuring
        // Syntax 1
        // let { a, b, c } = this.state
        //
        // Syntax 2
        // let a, b, c    <--- Declare variable first
        // ( { a, b, c } = this.state ) <--- Assign value. Note: Need enclose with bracket
        if (row.calculated && typeof row.calculated.rate !== 'undefined') {
            // use cached value to do calculation
            ( { rate, base, rateMsg } = row.calculated )
        }
        else {
            // Calculate the fee from raw data
            ( { rate, base, rateMsg } = CalculationHelper.getRate(row) )
        }

        if (rate || base) {
            let bills = row.bills
            if (bills && Array.isArray(bills) && bills.length > 0) {
                let bill = bills[0]
                let chargeable = CalculationHelper.getSettlementRawValue(row, bill)
                let baseAmount = (base && parseFloat(base)) || 0.0
                let percentageAmount = (rate && chargeable * rate * 0.01) || 0.0

                const fee = CalculationHelper.round2dp(baseAmount + percentageAmount)
                return fee
            }
        }
        return '--'
    }
}